import { Component, Input } from '@angular/core';
import { ReconciliationService } from '../../services/reconciliation.service';
import { UserService } from '../../services/user.service';
import { User } from '../../models';

@Component({
  selector: 'app-opening-fees',
  standalone: false,
  templateUrl: './opening-fees.component.html',
  styleUrl: './opening-fees.component.css',
})
export class OpeningFeesComponent {
  @Input() uuid!: string;
  @Input() user!: User;
  loading = false;
  bypassing = false;
  openingFee: any = null;

  constructor(
    private reconciliationService: ReconciliationService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.loadOpeningFees(this.uuid);
  }

  loadOpeningFees(uuid: string) {
    this.loading = true;

    this.reconciliationService.getOpeningFees(uuid).subscribe((response) => {
      this.openingFee = response;
      this.loading = false;
    });
  }

  downloadBase64File(
    base64Data: string,
    mode: 'download' | 'open' = 'download'
  ) {
    base64Data = base64Data.replace(/\s+/g, '');

    const matches = base64Data.match(/^data:(.+);base64,(.+)$/);
    if (!matches) {
      console.error('Invalid base64 string.');
      return;
    }

    const mimeType = matches[1];
    const extension = mimeType.split('/')[1];
    const byteString = atob(matches[2]);
    const byteNumbers = new Array(byteString.length);

    for (let i = 0; i < byteString.length; i++) {
      byteNumbers[i] = byteString.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    const blobUrl = URL.createObjectURL(blob);

    if (mode === 'open') {
      window.open(blobUrl, '_blank');
    } else {
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = `PROOF-${this.uuid}.${extension}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  formatFieldName(field: string): string {
    // Replace underscores with spaces and capitalize the first letter of each word
    return field
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  bypassOpeningFee() {
    if (this.bypassing) return;

    this.bypassing = true;
    this.userService.bypassOpeningFee(this.uuid).subscribe({
      next: () => {
        this.bypassing = false;
        this.user.has_paid_opening_fees = true;
        this.loadOpeningFees(this.uuid);
      },
      error: () => {
        this.bypassing = false;
      },
    });
  }
}
